import { RouteConfig } from "vue-router";
import { RCandidateTasksBrowse } from "./browse/RCandidateTasksBrowse";
import { RCandidateTasksTemplate } from "./template/RCandidateTasksTemplate";

export const RCandidateTasks: RouteConfig = {
  path: "cases/tasks",
  component: () =>
    import(
      /* webpackChunkName: "candidate-tasks" */
      "./VCandidateTasks.vue"
    ),
  children: [RCandidateTasksBrowse, RCandidateTasksTemplate],
};
